import {wrapIn} from "prosemirror-commands";

import {schema} from "../../config/schema";
import {toggleWrap, canWrap} from "../../../utils/wrap";

export const toggleWrapBlockquote = toggleWrap(schema.nodes.blockquote);
export const canToggleWrapBlockquote = canWrap(schema.nodes.blockquote);
export const wrapInBlockquote = wrapIn(schema.nodes.blockquote)
